<template>
  <div class="f-c">
    <div class="stack-basic">
      <div class="title f-r">
        <span class="content">{{ rowNo }}-{{ stackNo }}</span>
      </div>
    </div>
    <div class="f-r stack-section">
      <basic-table
        class="stackPartTable"
        :table-data="sectionData"
        :table-headers="stackSectionTableHeaders"
        :show-pagination="false"
      />
      <div class="f-c graph-container">
        <div
          class="stack-part-graph"
          v-for="(part, index) in sectionData"
          :key="'part' + index"
        >
          <span class="sectionNo">{{ part.sectionNo }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// components
import BasicTable from '@/components/common/BasicTable.vue'

export default {
  name: 'StackSection',
  props: {
    rowNo: {
      type: String,
      required: true
    },
    stackNo: {
      type: String,
      required: true
    },
    sectionData: {
      type: Array,
      default: () => []
    },
    stackSectionTableHeaders: {
      type: Array,
      required: true
    }
  },
  components: {
    BasicTable
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.title {
  gap: 20px;
  font-size: 32px;

  span {
    font-weight: bold;
    font-size: 48px;
  }

  margin-bottom: 10px;
}

.stack-section {
  gap: 20px;

  .stackPartTable {
    width: 85%;
  }

  .graph-container {
    gap: 10px;
    width: 15%;
    margin-top: 38px;
    margin-bottom: 5px;

    .stack-part-graph {
      height: 100%;
      background-color: $el-danger-color;
      flex-grow: 1;
      border-radius: 12px;
      position: relative;

      .sectionNo {
        font-size: 40px;
        color: white;
        font-weight: bold;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        transform: translateX(-50%) translateY(-50%);
        transform: translateX(-50%) translateY(-50%);
      }
    }
  }
}
</style>
